<div class="events-container">
  <ag-grid-angular
    class="ag-theme-balham-dark events-container__ag-grid"
    [enableRangeSelection]="true"
    [columnDefs]="headers"
    [defaultColDef]="defaultColDef"
    [autoGroupColumnDef]="{ sortable: true }"
    rowSelection="multiple"
    [groupSelectsChildren]="true"
    [suppressRowClickSelection]="true"
    [sideBar]="sideBarDef"
    (gridReady)="onGridReady($event)"
    (sortChanged)="gridStateChanged($event)"
    (columnResized)="gridStateChanged($event)"
    (columnVisible)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPivotChanged)="gridStateChanged($event)"
    (columnRowGroupChanged)="gridStateChanged($event)"
    (columnValueChanged)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPinned)="gridStateChanged($event)"
    [rowData]="rowData"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  >
  </ag-grid-angular>

  <div class="events-container__footer">
    <div class="events-container__footer__info">
      <ng-container *ngIf="state.info">{{ state.info }}</ng-container>
      <ng-container
        *ngIf="state.runningState === RunningState.Running && !state.info"
      >
        Report running. Some reports might take a while.
      </ng-container>
    </div>

    <form [formGroup]="form">
      <div class="clr-form-control">
        <label class="clr-control-label">Start Date</label>
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input
              type="text"
              placeholder="YYYY-MM-DD"
              class="clr-input"
              spellcheck="false"
              autocomplete="off"
              formControlName="start_date"
            />
          </div>
        </div>
      </div>
      <div class="clr-form-control">
        <label class="clr-control-label">Start Time</label>
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input
              type="text"
              placeholder="HH:MM"
              class="clr-input"
              spellcheck="false"
              autocomplete="off"
              formControlName="start_time"
            />
          </div>
        </div>
      </div>
      <div class="clr-form-control">
        <label class="clr-control-label">End Date</label>
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input
              type="text"
              placeholder="YYYY-MM-DD"
              class="clr-input"
              spellcheck="false"
              autocomplete="off"
              formControlName="date"
            />
          </div>
        </div>
      </div>
      <div class="clr-form-control">
        <label class="clr-control-label">End Time</label>
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input
              type="text"
              placeholder="HH:MM"
              class="clr-input"
              spellcheck="false"
              autocomplete="off"
              formControlName="time"
            />
          </div>
        </div>
      </div>
      <app-selector
        [isSearch]="true"
        [passedItems]="timezones"
        placeholder="Timezone"
        formControlName="timezone"
      ></app-selector>
      <app-selector
        [isSearch]="true"
        [passedItems]="entities"
        placeholder="Select an entity or type to search"
        formControlName="entity"
      ></app-selector>
    </form>
    <div class="events-container__footer__buttons">
      <button
        type="button"
        class="ui-button ui-button__header ui-button--danger"
        [disabled]="state.runningState === RunningState.Idle"
        (click)="cancelReport()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ui-button ui-button__header ui-button--primary"
        [disabled]="
          state.runningState === RunningState.Running || !canRunReport()
        "
        (click)="runReport()"
      >
        Run
      </button>
    </div>
  </div>
</div>
